import React, { forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CrossIcon from 'src/assets/images/CloseProduct.svg';
import ArrowLeft from 'src/assets/images/LeftArrowBlue.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    DialogContentContainer,
    NoUsageHeader,
    NoUsageTitle,
    NoUsageButtonContainer,
    CrossIconImg,
    NoUsageFooterContainer,
    BackButton,
} from './noUsageToReport.styled';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { sizes } from 'src/styles/Media.styled';
import {
    closeOrderSummaryModalState,
    toggleSearchResult,
} from 'src/pages/orders/redux/actions';
import { unlockOrderFunc } from '../../redux/saga/dataServices';
import { removeEmptyFieldsFromObject } from 'src/utils/util';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';
import { updateSurgery } from 'src/pages/scheduleSurgery/redux/actions';
import { getDisplayDate, getRddDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';

const CaseCancelOrUnidPostpone = forwardRef(({
    cancelSurgeryData,
    backBtnClickHandler,
    // isFromOrderDetailsModal,
    // showUnidPostponePopup,
}, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const shippingDetails = useSelector(
        (state) => state.surgeryReducer.shippingDetails
    );
    const orderStatusDescription = useSelector(
        (state) =>
            state.surgeryDetailsReducer.surgeryData?.orderStatusDescription
    );
    const defaultshipToAddress = useSelector((state) => {
        return state.shipToAddressReducer.shipToAddress?.nonTissueAddress;
    });
    const accountIdAddress = useSelector((state) => {
        return state.shipToAddressReducer.shipToAddress.accountId;
    });
    const notes = useSelector((state) => state.surgeryReducer.notes);

    const { showSearchModal } = useSelector(
        (state) => state.appliedOrdersSearchReducer
    );
    const { surgeryDetails, cartData, pricingNotes, productTemplateUID } =
        useSelector((state) => ({
            surgeryDetails: state.surgeryReducer.surgeryDetails,
            cartData: state.surgeryReducer.cartData,
            pricingNotes: state.surgeryReducer.pricingNotes,
            productTemplateUID: state.surgeryReducer.productTemplateUID,
            timeZoneOffset: state.surgeryReducer.surgeryDetails.timeZoneOffset,
            surgeryDateTime:
                state.surgeryReducer.surgeryDetails.surgeryDateTime,
            unknownCheckbox: state.surgeryReducer.unknownCheckbox,
        }));

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const cancelSurgeryBtnsClickHandler = () => {
        const surgeryDetailsFormatted = removeEmptyFieldsFromObject({
            ...surgeryDetails,
            patientDOB: surgeryDetails.patientDOB
                ? getRddDate(surgeryDetails.patientDOB, 'YYYY-MM-DD')
                : '',
            patientContactNumber:
                countryISOCode === US_COUNTRY_CODE
                    ? surgeryDetails.patientContactNumber.replace(/\D/g, '')
                    : surgeryDetails.patientContactNumber.replace(
                          /[a-zA-Z]/g,
                          ''
                      ),
        });
        delete surgeryDetailsFormatted.inventoryShipping;
        delete surgeryDetailsFormatted.uniDId;
        delete surgeryDetailsFormatted.planStatus;
        delete surgeryDetailsFormatted.lastModifiedDate;
        delete surgeryDetailsFormatted.lastModifiedBy;
        delete surgeryDetailsFormatted.accountName;
        delete surgeryDetailsFormatted.physicianName;
        delete surgeryDetailsFormatted.accountTimeZone;
        delete surgeryDetailsFormatted.timeZoneOffset;

        const clonedCartData = JSON.parse(JSON.stringify(cartData));
        const cartDataFormatted = removeEmptyFieldsFromObject({
            ...clonedCartData,
        });
        cartDataFormatted.products = cartDataFormatted.products
            .filter((product) => product.quantity > 0)
            .map((product) => {
                delete product.brand;
                delete product.dailyRate;
                // delete product.description;
                delete product.isSet;
                delete product.salesOrg;
                delete product.uom;
                delete product.error;
                !product.batchAlreadyAllocated &&
                    delete product.batchAlreadyAllocated;
                !product.batchCurrentLocation &&
                    delete product.batchCurrentLocation;
                !product.batchId && delete product.batchId;
                !product.batchParked && delete product.batchParked;
                return product;
            });

        delete cartDataFormatted.templateUId;
        const modifyShippingData = Object.values(shippingDetails).filter(
            (item) => item.shippingAddressId !== ''
        );
        const surgeryTempUID = surgeryDetails?.template?.templateUID
            ? surgeryDetails?.template?.templateUID
            : '';

        const prodTempUID =
            surgeryTempUID.trim() !== '' && productTemplateUID.trim() !== ''
                ? ',' + productTemplateUID
                : surgeryTempUID.trim() === '' &&
                  productTemplateUID.trim() !== ''
                ? productTemplateUID
                : '';

        const tempTemplateUId = surgeryTempUID + prodTempUID;
        surgeryDetails?.accountId == accountIdAddress &&
            modifyShippingData.map((ele) => {
                return {
                    ...ele,
                    shippingAddressId: defaultshipToAddress[0].addressId,
                };
            });
        cartDataFormatted.products = cartDataFormatted.products.map(
            (product) => {
                product.isFeedAddedLPSet = product?.isFeedAddedLPSet
                    ? product.isFeedAddedLPSet
                    : false;
                product.dontSendToSAP = product?.isFeedAddedLPSet
                    ? modifyShippingData && modifyShippingData?.length > 0
                        ? false
                        : true
                    : false;
                return product;
            }
        );

        const surgery = {
            surgeryDetails: surgeryDetailsFormatted,
            shippingDetails: modifyShippingData,
            cartData: {
                ...cartDataFormatted,
                templateUId:
                    tempTemplateUId?.trim().length > 0
                        ? tempTemplateUId.split(',')
                        : [],
            },
            notes: notes,
            pricingNotes: pricingNotes,
            isSubmitted: false,
            isUnidPostponedFlow: false,
            isUnidCaseCancelledOrPostponed: true,
            visualInspectionAcknowledgement: true,
            orderStatusDescription: orderStatusDescription,
        };
        surgery.myCASERef = cancelSurgeryData.myCaseRef;
        surgery.isSubmittedFromSurgeryFlow = false;
        dispatch(updateSurgery(surgery));
        // }
        redirectToCalendarOrOrdersPage();
    };

    const redirectToCalendarOrOrdersPage = () => {
        (cancelSurgeryData?.myCaseRef && cancelSurgeryData?.myCaseRef?.length > 0) && unlockOrderFunc({
            action: 'NoUsageToReport',
            myCaseRefId: cancelSurgeryData?.myCaseRef,
        });
        // cancelSurgeryBtnsClickHandler(false);
        backBtnClickHandler();
        dispatch(
            closeOrderSummaryModalState({
                myCaseRef: '',
                orderSummaryModal: false,
            })
        );
        if (showSearchModal) {
            dispatch(toggleSearchResult(false));
        }
    };

    // ...existing code...

    // Expose redirectToCalendarOrOrdersPage via imperative handle
    useImperativeHandle(ref, () => ({
        redirectToCalendarOrOrdersPage
    }), []);

    return (
        <React.Fragment>
            <DialogContentContainer>
                <NoUsageHeader>
                    <NoUsageTitle>
                        {t(
                            'noUsageToReport.CaseCancelOrUnidPostpone.NoUsageTitle'
                        )}
                    </NoUsageTitle>
                    {/* <CrossIconImg
                        path={CrossIcon}
                        onClick={redirectToCalendarOrOrdersPage}
                    /> */}
                </NoUsageHeader>
                {/* <BackButton onClick={() => backBtnClickHandler(false)}>
                    <img src={ArrowLeft}></img>
                    <span>Back</span>
                </BackButton> */}
                <StyledTextDiv
                    color={'#000000'}
                    letterSpacing={'-0.11px'}
                    fontSize={'14px'}
                    fontFamily={'AvenirNextWorld Regular'}
                    padding={
                        window.innerWidth <= sizes.mobileDevice
                            ? '15px 0'
                            : '10px 15px 35px 5px'
                    }
                >
                    {t(
                        'noUsageToReport.CaseCancelOrUnidPostpone.receiveReminder'
                    )}
                </StyledTextDiv>
                <NoUsageFooterContainer isCancelPopup>
                    <NoUsageButtonContainer>
                        <Button
                            id={'reportUsage-noUsageToReport-cancelSurgeryBtn'}
                            show
                            width={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '160px'
                                    : '130px'
                            }
                            height={'38px'}
                            variant={ButtonStyles?.cancel}
                            //cancel
                            // borderRadius={'19px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => cancelSurgeryBtnsClickHandler(true)}
                        >
                            {'OK'}
                        </Button>
                        <Button
                        id={'reportUsage-noUsageToReport-cancelSurgeryBtn'}
                            show
                            width={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '160px'
                                    : '130px'
                            }
                            height={'38px'}
                            // primary
                            variant ={ButtonStyles?.primary}
                            margin={
                                window.innerWidth > sizes.mobileDevice &&
                                '0 29px 0 16px'
                            }
                            // borderRadius={'19px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={redirectToCalendarOrOrdersPage}
                        >
                            {t('common.cancelButton')}
                        </Button>
                    </NoUsageButtonContainer>
                </NoUsageFooterContainer>
            </DialogContentContainer>
        </React.Fragment>
    );
});

export default CaseCancelOrUnidPostpone;
